import React, { useState, useContext } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    Box,
    Button,
    Card,
    CardContent,
    TextField,
    Grid,
    Checkbox,
    FormControlLabel,
    makeStyles
} from '@material-ui/core';
import { useTranslation } from "react-i18next";
import SecureFetchContext from 'context/SecureFetchContext';
import getApiRoute from 'routes/apiRoutes';
import { useNavigate } from "react-router-dom";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import AppContext from 'context/AppContext';

const useStyles = makeStyles(() => ({
    root: {}
}));

const NewServiceForm = ({ className, states, edit, ...rest }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const secureFetch = useContext(SecureFetchContext);
    const [values, setValues] = useState({});
    let navigate = useNavigate();
    const { appValues } = useContext(AppContext);

    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        secureFetch(getApiRoute('admin_service'), values, 'POST').then(json => {
            navigate('/app/admin/service/list');
        });
    };

    const handleCheckboxChange = (event) => {
        setValues({ ...values, [event.target.name]: event.target.checked });
    };

    return (
        <form
            autoComplete="off"
            className={clsx(classes.root, className)}
            onSubmit={handleSubmit}
            {...rest}
        >
            <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                    <Card>
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label={t('label.code')}
                                        name="code"
                                        onChange={handleChange}
                                        value={values.code || ''}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label={t('label.name')}
                                        name="name"
                                        onChange={handleChange}
                                        value={values.name || ''}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl className={classes.formControl} fullWidth>
                                        <InputLabel id="shipper">{t('label.shipper')}</InputLabel>
                                        <Select
                                            labelId="shipper"
                                            value={ values.shipper || '' }
                                            name="shipper"
                                            onChange={handleChange}
                                            required
                                        >
                                            {appValues.shippers.map((option) => (
                                                <MenuItem 
                                                    key={option.id}
                                                    value={option.id}
                                                >
                                                    {option.shortcut}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label={t('label.input_name')}
                                        name="input_name"
                                        onChange={handleChange}
                                        value={values.input_name || ''}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl className={classes.formControl} fullWidth>
                                        <InputLabel id="input_type">{t('label.input_type')}</InputLabel>
                                        <Select
                                            labelId="input_type"
                                            value={ values.input_type !== undefined ? values.input_type : '' }
                                            name="input_type"
                                            onChange={handleChange}
                                        >
                                            {appValues.inputTypes.map((option) => (
                                                <MenuItem 
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label={t('label.description')}
                                        name="description"
                                        onChange={handleChange}
                                        value={values.description || ''}
                                        rows={4}
                                        multiline
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        autoFocus
                                        name="enabled_from"
                                        label={t('label.enabled_from')}
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={values.enabled_from || ''}
                                        fullWidth
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        autoFocus
                                        name="enabled_to"
                                        label={t('label.enabled_to')}
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={values.enabled_to || ''}
                                        fullWidth
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={values.visible ? true : false}
                                                onChange={handleCheckboxChange}
                                                name="visible"
                                                color="primary"
                                            />
                                        }
                                        label={t('label.visible')}
                                    />
                                </Grid>
                            </Grid>

                        </CardContent>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button color="primary" variant="contained" type="submit">
                                {t('button.create')}
                            </Button>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </form>
    );
};

NewServiceForm.propTypes = {
    className: PropTypes.string
};

export default NewServiceForm;
